import { Card, Table, Text } from "@radix-ui/themes";
import React, { useMemo } from 'react';
import { Controller, useWatch } from "react-hook-form";
import CheckboxComponent from "../../components/inputs/Checkbox/CheckboxComponent";
import { AssessmentType } from "../../types/Assessment";
import { StudentClassType } from '../../types/Student';
import { stringToBoolean } from "../../utils/utilities";

interface StudentGradesFormProps {
  students: Array<StudentClassType>;
  assessment: AssessmentType;
  control: any;
  errors: any;
  setValue?: any;
  getValues?: any;
  watch?: any;
  readonly?: boolean;
}

export const BlockOrUnblockStudentGradePostingForm: React.FC<StudentGradesFormProps> = ({ students, assessment, control, errors, setValue, getValues, readonly, watch }) => {

  const handleCheckBoxSelectAll = (checked: boolean) => {
    students.map((item, studentIndex) => {
      setValue(`studentAssessment.${studentIndex}.assessment.isBlocked`, checked)
    });
  }

  return (
    <Card>
      <Table.Root>
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeaderCell>Nome</Table.ColumnHeaderCell>
            {control &&
              <Table.Cell>
                <CheckboxComponent
                  name='selectAll'
                  label='Bloquear todos?'
                  control={control || undefined}
                  errors={errors || {}}
                  onChange={handleCheckBoxSelectAll}
                />
              </Table.Cell>
            }
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {students?.map((student, studentIndex) => {

            return (
              <Table.Row key={student.idStudent}>
                <Table.Cell>
                  <Text weight="bold">{student.student}</Text>
                </Table.Cell>
                <Table.Cell>
                  <CheckboxComponent
                    name={`studentAssessment.${studentIndex}.assessment.isBlocked`}
                    label="Bloquear?"
                    control={control}
                    errors={errors}
                    onChange={(checked) => {
                      console.log(`Checkbox do estudante ${student.student} mudou para:`, checked);
                    }}
                  />
                  {errors?.studentAssessment?.[studentIndex]?.assessment.isBlocked && (
                    <Text color="red" size="1">{`${errors?.studentAssessment?.[studentIndex]?.assessment?.isBlocked?.message}`}</Text>
                  )}
                  <Controller
                    control={control}
                    name={`studentAssessment.${studentIndex}.assessment.idAssessment`}
                    defaultValue={assessment.id}
                    render={({ field }) => <input type="hidden" {...field} />}
                  />
                  <Controller
                    control={control}
                    name={`studentAssessment.${studentIndex}.assessment.id`}
                    defaultValue={student.idStudent}
                    render={({ field }) => <input type="hidden" {...field} />}
                  />
                </Table.Cell>

              </Table.Row>
            );
          })}
        </Table.Body>
      </Table.Root>
    </Card>
  );
};